import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Check, Loader2, XCircle } from "lucide-react";
import { api } from "../lib/api";

export default function Unsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState("working");

  useEffect(() => {
    document.title = "Unsubscribed — HiPlate";
    api.get(`/unsubscribe/${token}`).then(() => setState("done")).catch(() => setState("invalid"));
  }, [token]);

  return (
    <main className="grain flex min-h-[80vh] items-center justify-center bg-parchment px-4 pt-32 pb-20" data-testid="unsubscribe-page">
      <div className="w-full max-w-md rounded-3xl border border-inkline bg-cream p-10 text-center">
        {state === "working" && <Loader2 size={36} className="mx-auto animate-spin text-spice" />}
        {state === "done" && (
          <>
            <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-halal/15"><Check size={30} className="text-halal" /></span>
            <h1 className="mt-6 font-display text-3xl font-semibold text-ink" data-testid="unsubscribe-done">You're unsubscribed.</h1>
            <p className="mt-3 text-sm leading-relaxed text-muted2">No more weekly menu emails. You'll still get receipts for anything you order. Changed your mind? Re-enter your email in the footer anytime.</p>
          </>
        )}
        {state === "invalid" && (
          <>
            <XCircle size={36} className="mx-auto text-spice" />
            <h1 className="mt-6 font-display text-3xl font-semibold text-ink" data-testid="unsubscribe-invalid">That link isn't valid.</h1>
            <p className="mt-3 text-sm leading-relaxed text-muted2">Reply to any of our emails with "unsubscribe" and we'll take care of it by hand.</p>
          </>
        )}
        <Link to="/" className="mt-8 inline-block rounded-full bg-ink px-7 py-3.5 text-sm font-semibold text-parchment transition-colors hover:bg-spice" data-testid="unsubscribe-home">Back to HiPlate</Link>
      </div>
    </main>
  );
}
